import { render, staticRenderFns } from "./foot-box.vue?vue&type=template&id=aa06c880"
import script from "./foot-box.vue?vue&type=script&lang=js"
export * from "./foot-box.vue?vue&type=script&lang=js"
import style0 from "./foot-box.vue?vue&type=style&index=0&id=aa06c880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports